import React, { useEffect, useState, useCallback } from 'react'
import { inject, observer } from 'mobx-react'
import { Button, message, Input, Row, Col, Space } from 'antd'
import { PlusOutlined, SearchOutlined, ReloadOutlined } from '@ant-design/icons'
import SalaryVpListTable from './SalaryVpListTable'
import { useHistory } from 'react-router-dom'
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout'
import { Helmet } from 'react-helmet'
import PageTitle from '../../components/PageTitle'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'

const SalaryVpListPage = props => {
  const { salaryVpStore, loadingAnimationStore, userStore } = props
  const {
    salaryVpListPage,
    getSalaryVpList,
    deleteSalaryVp,
    approveSalaryVp,
    salaryVpQueryParam,
    setSalaryVpQueryParam,
  } = salaryVpStore
  const history = useHistory()

  const [keyword, setKeyword] = useState('')
  const [createdUser, setCreatedUser] = useState('')

  const fetchData = useCallback(async () => {
    loadingAnimationStore.showSpinner(true)
    try {
      await getSalaryVpList()
    } catch (err) {
      message.error('Lỗi khi tải danh sách bảng lương')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }, [getSalaryVpList, loadingAnimationStore])

  useEffect(() => {
    fetchData()
  }, [fetchData, salaryVpQueryParam.page, salaryVpQueryParam.size])

  useEffect(() => {
    if (userStore && userStore.userList.length === 0) {
      userStore.getUserListV2()
    }
  }, [userStore])

  const handleSearch = () => {
    setSalaryVpQueryParam({
      page: 0,
      keyword: keyword,
      created_user: createdUser,
    })
    fetchData()
  }

  const handleReset = () => {
    setKeyword('')
    setCreatedUser('')
    setSalaryVpQueryParam({
      page: 0,
      keyword: null,
      created_user: null,
    })
    fetchData()
  }

  const handleDelete = async code => {
    try {
      await deleteSalaryVp(code)
      message.success('Đã xóa bảng lương')
      fetchData()
    } catch (err) {
      message.error('Lỗi khi xóa bảng lương')
    }
  }

  const handleApprove = async code => {
    try {
      await approveSalaryVp(code)
      message.success('Đã duyệt bảng lương')
      fetchData()
    } catch (err) {
      message.error('Lỗi khi duyệt bảng lương')
    }
  }

  return (
    <DashboardLayout>
      <Helmet>
        <title>Bảng Lương</title>
      </Helmet>
      <PageTitle location={props.location} title={'Bảng Lương'} hiddenGoBack>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => history.push('/salary/create')}>
          Tạo bảng lương mới
        </Button>
      </PageTitle>

      {/* <ContentBlockWrapper style={{ marginBottom: 16 }}>
        <Row gutter={16}>
          <Col span={8}>
            <Input
              placeholder="Tìm kiếm theo tiêu đề"
              value={keyword}
              onChange={e => setKeyword(e.target.value)}
              onPressEnter={handleSearch}
            />
          </Col>
          <Col span={8}>
            <Input
              placeholder="Nhập tên người tạo"
              value={createdUser}
              onChange={e => setCreatedUser(e.target.value)}
              onPressEnter={handleSearch}
            />
          </Col>
          <Col span={8}>
            <Space>
              <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>
                Tìm kiếm
              </Button>
              <Button icon={<ReloadOutlined />} onClick={handleReset}>
                Làm mới
              </Button>
            </Space>
          </Col>
        </Row>
      </ContentBlockWrapper> */}

      <ContentBlockWrapper className="salary-vp-list-page">
        <SalaryVpListTable
          dataSource={salaryVpListPage}
          userStore={userStore}
          onDelete={handleDelete}
          onApprove={handleApprove}
          onView={code => history.push(`/salary/view/${code}`)}
        />
      </ContentBlockWrapper>
    </DashboardLayout>
  )
}

export default inject(
  'salaryVpStore',
  'userStore',
  'loadingAnimationStore'
)(observer(SalaryVpListPage))
